import {ValueObject} from '@s-ui/domain'

/**
 * @export
 * @class SaitamaConfigurationValueObject
 * @extends {ValueObject}
 */
export class SaitamaConfigurationValueObject extends ValueObject {}
